const state = {
    asignarAulaAsientoList: null,
    textFilter: '',
    listEscuelas:null,
    listAulas:null,
    data_proceso_admision:null,
}

export default state